module.exports = __webpack_public_path__ + "img/red_middleschool.22536073.svg";